<template>
  <div class="block1">
    <img class="b1-img1" src="@/assets/logo_youren.png" alt="">
    <ul class="b1-ul" v-if="!isMobile">
      <li v-for="(item, index) in list" :key="index">
        <a
          :id="'a' + index"
          :class="{active: activeIndex == index}"
          :href="item.router"
          @mouseenter="showSubMenu(index)"
          @mouseleave="hideSubMenu(index)"
        >{{item.name}}</a>
      </li>
    </ul>
    <div v-if="isMobile" class="navbar-toggle" @click="showMenu = !showMenu">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </div>
    <div class="list-c">
      <transition name="menu">
        <ul class="b1-ul3" v-if="isMobile && showMenu">
          <li v-for="(item, index) in list" :key="index">
            <a
              :id="'a' + index"
              :class="{active: activeIndex == index}"
              :href="item.router"
            >{{item.name}}</a>
          </li>
        </ul>
      </transition>
    </div>
    <ul
      class="b1-ul2"
      :class="{activeSub: activeSub}"
      :style="ul2Style"
      @mouseenter="showSubMenu(1)"
      @mouseleave="hideSubMenu(1)"
    >
      <li>
        <a href="./product">硬件介绍</a>
      </li>
      <li>
        <a href="./productsoft">软件介绍</a>
      </li>
    </ul>
  </div>
</template>

<script>
import util from "../utils/util.js";

export default {
  name: "Navi",
  props: ["activeIndex", "activeSub"],
  data() {
    return {
      list: [
        { router: "./", name: "首页" },
        { router: "./product", name: "产品介绍" },
        { router: "./casedata", name: "案例数据" },
        { router: "./news", name: "新闻中心" },
        { router: "./aboutus", name: "公司简介" },
        { router: "./contact", name: "联系我们" }
      ],
      ul2Style: {
        display: "none"
      },
      isMobile: util.isMobile(),
      showMenu: false
    };
  },
  methods: {
    showSubMenu(index) {
      if (index != 1) {
        return;
      }
      this.ul2Style.display = "block";
    },
    hideSubMenu(index) {
      if (index != 1) {
        return;
      }
      this.ul2Style.display = "none";
    }
  }
};
</script>

<style scoped>
.block1 {
  height: 126px;
  padding: 0px 80px 0px 150px;
  background-color: rgb(255, 255, 255);
}
.b1-img1 {
  float: left;
  margin-top: 40px;
  width: 150px;
}

.b1-ul {
  display: inline-block;
  float: right;
  margin: 0px;
}

.b1-ul li {
  width: 120px;
  display: inline-block;
}

.b1-ul li a {
  display: inline-block;
  color: #666;
  font-size: 22px;
  height: 119px;
  line-height: 126px;
}
.active {
  color: #ea6841 !important;
}
.b1-ul li a:hover {
  color: #ea6841;
  border-bottom: 7px solid #ea6841;
}
.b1-ul2 {
  height: 66px;
  width: 100%;
  background-color: #999;
  position: absolute;
  top: 125px;
  left: 0;
  right: 0;
  margin: 0px;
  padding: 0px;
  display: block;
}
.b1-ul2 li {
  display: inline-block;
  width: 200px;
  height: 66px;
}
.b1-ul2 li a {
  color: white;
  font-size: 26px;
  line-height: 66px;
  height: 100%;
}
.activeSub {
  display: block !important;
}

@media only screen and (max-width: 800px) {
  .block1 {
    padding: 0px 0px;
    height: auto;
  }
  .b1-img1 {
    margin-top: 25px;
    margin-left: 30px;
  }
  .navbar-toggle {
    margin-top: 20px;
    padding-top: 12px;
    width: 50px;
    height: 42px;
    border: solid 1px #ea6841;
    float: right;
    margin-right: 30px;
    border-radius: 4px;
  }
  .icon-bar {
    display: block;
    width: 30px;
    margin: 6px auto;
    height: 3px;
    border-radius: 1px;
    background-color: #ea6841;
  }
  .list-c {
    padding-top: 100px;
  }
  .b1-ul3 {
    background: #666;
    display: block;
    margin: 0px;
    padding: 0px;
    max-height: 600px;
    overflow: hidden;
  }
  .b1-ul3 li {
    height: 66px;
  }
  .b1-ul3 li a {
    color: white;
    font-size: 26px;
    line-height: 66px;
    height: 100%;
  }
  .menu-enter-active,
  .menu-leave-active {
    transition: max-height 0.5s;
  }
  .menu-enter,
  .menu-leave-to {
    max-height: 0px;
  }
  .b1-ul2 {
    position: relative;
    top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navi.vue